import {
  AudienceCountInput,
  AudienceInstance,
  AudienceType,
} from '@/client/services/api/graphql/gql/graphql';

import AdminAssignmentsService from '@/client/components/admin/assignments/api/AdminAssignmentsService';
import type { AssignmentFormData } from '../../types/assignmentTypes';
import { useFormContext } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';

export const useGetAssignentAudienceCount = (audience: AudienceInstance[]) => {
  const { watch } = useFormContext<AssignmentFormData>();
  const { audienceIsAll } = watch();
  const { simpleType } = watch();

  const payload: AudienceCountInput[] = audience.map((audienceItem) => ({
    dateRange: audienceItem.dateRange,
    days: audienceItem.days,
    id: audienceItem.id,
    matchingCriteria: audienceItem.matchingCriteria,
    type:
      audienceItem.type === AudienceType.PartnerType
        ? AudienceType.PartnerType
        : audienceItem.type === AudienceType.HiredDate
        ? AudienceType.HiredDate
        : audienceItem.segmentationType === 'group'
        ? AudienceType.Group
        : audienceItem.segmentationType === 'user'
        ? AudienceType.User
        : AudienceType.Segment,
  }));

  const queryIsEnabled = simpleType !== 'automated' && (audienceIsAll || audience.length > 0);

  return useQuery({
    enabled: queryIsEnabled,
    queryKey: ['assignment-audience-count', payload, audienceIsAll],
    queryFn: () =>
      AdminAssignmentsService.getAssignmentAudienceCount(payload as AudienceCountInput[]),
  });
};
